import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import { Table, Empty, Col, Row, message, Tooltip } from "antd";
import { OrderedListOutlined, FileExcelOutlined } from "@ant-design/icons";
import { ColumnHelper } from "../../util/TableHelper";
import { useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import config from "util/ApiforContext";
import EmployeeTransactionListFilter from "../Filters/EmployeeTransactionListFilter";

const EmployeeTransactionsReport = (props) => {
  const [options, setOptions] = useState({
    pageTitle: "PERSONEL MAAŞ HAREKETLERİ RAPORU",
  });
  const [tableData, setTableData] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [dataState, setDataState] = useState([{ skip: 0, take: 20 }]);
  const [query, setQuery] = useState("");

  useEffect(() => getTableData(), [tableDataQueryOptions]);

  const history = useHistory();

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = "";
    const { skip, take, filter } = tableDataQueryOptions;
    const order = "&$orderby=transactionDateValue desc";
    const conditions = [];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    setQuery(query + order);

    RequestHandler.get(
      `/EmployeeTransaction?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const columns = [
    {
      title: "Personel Adı",
      dataIndex: "firmName",
      key: "firmName",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return text.substring(0, 25).length < 25
          ? text.substring(0, 25) + ""
          : text.substring(0, 25) + "...";
      },
    },
    {
      title: "İşlem Tarihi",
      dataIndex: "transactionDate",
      key: "transactionDate",
      align: "left",
    },
    {
      title: "İşlem Tipi",
      dataIndex: "processTypeName",
      key: "processTypeName",
      align: "left",
    },
    {
      title: "Açıklama",
      dataIndex: "description",
      key: "description",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return text.substring(0, 25).length < 25
          ? text.substring(0, 25) + ""
          : text.substring(0, 25) + "...";
      },
    },
    {
      title: "Maaş Planı",
      dataIndex: "paymentPlanTotalString",
      key: "collectTotalString",
      align: "center",
      align: "left",
      render: (text, row, index) => {
        {
          return <div style={{ width: 98, whiteSpace: "nowrap" }}>{text}</div>;
        }
      },
    },
    {
      title: "Ödenen Maaş",
      dataIndex: "paymentTotalString",
      key: "paymentTotalString",
      align: "left",
      render: (text, row, index) => {
        {
          return <div style={{ width: 98, whiteSpace: "nowrap" }}>{text}</div>;
        }
      },
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, _, sorter) => {
    let orderValue = "";
    if (sorter.columnKey && sorter.order) {
      orderValue =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }

    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
        order: orderValue,
      };
    });
  };

  const dataStateChange = (e) => {
    setTableData(e);
  };

  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);

    RequestHandler.post(
      "/EmployeeTransaction/ExportReportExcel",
      {
        query: query,
      },
      false
    ).then((response) => {
      hideMessage();

      if (response) {
        window.open(
          `${
            config.apiUrl
          }/EmployeeTransaction/DownloadReportExcel?fileName=${response}&t=${RequestHandler.getToken()}`
        );
      }
    });
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "end" }}>
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>
      <EmployeeTransactionListFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        isUseEmployeeId={true}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            onChange={paging}
            dataSource={tableData.data}
            loading={tableData.loading}
            pageable={true}
            pagination={{
              pageSizeOptions: ["20", "50", "100"],
              total: tableData.total,
              defaultPageSize: tableDataQueryOptions.take,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>
    </>
  );
};

export default EmployeeTransactionsReport;
